import(/* webpackMode: "eager" */ "/workspace/src/app/blog/error.tsx");
